// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// MODULES
import AccountHelpers from 'lib/helpers/AccountHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';
// ANTD
import Menu from 'antd/lib/menu';
// STYLES
// import '/imports/ui/layouts/app/index.less';

class DropdownMenu extends React.PureComponent {
  onLogout = async () => {
    try {
      await AccountHelpers.handleLogout();
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }
    window.location.reload();
  };
  render() {
    const { user } = this.props;
    return (
      <Menu className="heyned-dropdown">
        <Menu.Item>
          <p className="dropdown-header">Welcome, {(user && user.profile && user.profile.firstName) || ''}!</p>
        </Menu.Item>
        <Menu.Item key="/app/account" className="dropdown-menu-item" style={{ fontSize: 16 }}>
          <Link to="/app/account" className="dropdown-link">
            {' '}
            My Profile
          </Link>
        </Menu.Item>
        <Menu.Item key="/login" className="dropdown-menu-item" style={{ fontSize: 16 }}>
          <p className="dropdown-link" onClick={this.onLogout}>
            Logout
          </p>
        </Menu.Item>
      </Menu>
    );
  }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/layout/AppLayout/AppHeader/DropdownMenu/index.js